var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sceSelect',{ref:"field",attrs:{"value":_vm.value,"name":_vm.name,"label":'customField.' + _vm.config.label,"options":_vm.options,"config":{emptyLabel: 'none'}},on:{"input":function($event){return _vm.updateInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }